export default __webpack_public_path__ + "static/media/key-icon.dd2b6d82.svg";